import { Link } from "react-router-dom"

import { useBookingContext } from "modules/Booking/BookingContext"
import {
    setInformedAgreement,
    setOfferAccepted,
    setEulaAccepted,
} from "modules/Booking/FormPage/common"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { ContactsClient } from "modules/BookingCommon/components"
import style from "modules/Booking/FormPage/components/UserInfoWithForm/style.module.scss"
import { Checkbox } from "modules/Booking/FormPage/components/UserInfoWithForm/components/Checkbox"
import { ErrorsAcception } from "modules/Booking/FormPage/components/UserInfoWithForm/components/ErrorsAcception"
import { INDIVIDUAL_OFFER, INFORMED_AGREEMENT, OFFER_LINK } from "utils/env-management"

export function UserInfoWithForm() {
    const [{ psy, hasPreviousSessionsWithSamePsychologist }] = useBookingContext()
    const [
        {
            form: {
                name,
                email,
                phone,
                showErrors,
                offerAccepted,
                informedAgreement,
                eulaAccepted,
            },
        },
        { dispatch },
    ] = useFormPageContext()

    const [{ userAccount: clientUserAccount }] = useClientContext()

    const isB2b = clientUserAccount.is_b2b

    return (
        <>
            <ContactsClient name={name} phone={phone} email={email} />
            {!hasPreviousSessionsWithSamePsychologist && (
                <div>
                    <hr />
                    <div className={style.checkboxes}>
                        <Checkbox
                            checked={offerAccepted}
                            onChange={() => dispatch(setOfferAccepted(!offerAccepted))}
                            name="offerAccepted"
                            id="check_offer"
                        >
                            Соглашаюсь{" "}
                            <Link
                                target="_blank"
                                to={`${OFFER_LINK}?${psy.legal_info}`}
                                rel="noopener noreferrer"
                                className={style.link}
                            >
                                с&nbsp;офертой психолога
                            </Link>
                        </Checkbox>
                        {isB2b && (
                            <Checkbox
                                checked={informedAgreement}
                                onChange={() => dispatch(setInformedAgreement(!informedAgreement))}
                                name="informedAgreement"
                                id="informed_agreement"
                            >
                                Ознакомлен с&nbsp;
                                <Link
                                    to={`${INFORMED_AGREEMENT}?name=${psy.last_name} ${psy.first_name} ${psy.middle_name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={style.link}
                                >
                                    информированным согласием
                                </Link>
                            </Checkbox>
                        )}
                        <Checkbox
                            checked={eulaAccepted}
                            onChange={() => dispatch(setEulaAccepted(!eulaAccepted))}
                            name="ageAccepted"
                            id="check_age"
                        >
                            Принимаю{" "}
                            <Link
                                to={INDIVIDUAL_OFFER}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={style.link}
                            >
                                оферту сервиса
                            </Link>
                        </Checkbox>
                        {showErrors && (
                            <ErrorsAcception
                                psyOfferAccepted={offerAccepted}
                                eulaAccepted={eulaAccepted}
                                informedAgreement={(informedAgreement && isB2b) || !isB2b}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    )
}
